function setEqualHeight(elements) {
  let tallest = 0;
  elements.forEach(element => {
    element.style.height = 'auto';
    const currentHeight = element.offsetHeight;
    if (currentHeight > tallest) {
        tallest = currentHeight;
    }
  });
  elements.forEach(element => {
      element.style.height = tallest + 'px';
  });
}

function debounce(func, delay) {
  let timer;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(func, delay);
  };
}

window.productCardHeight = function() {
  try {
    if (typeof setEqualHeight !== 'function') return;
    const titles = document.querySelectorAll('.product__swatches--main');
    const prices = document.querySelectorAll('.product-item__price');
    titles.length && setEqualHeight([...titles]);
    prices.length && setEqualHeight([...prices]);
  } catch (e) {
    console.error('productCardHeight error:', e);
  }
}

// window.addEventListener("resize", debounce(function() {
//   const productTitles = Array.from(document.querySelectorAll('.product__swatches--main'));
//   const productPrice = Array.from(document.querySelectorAll('.product-item__price'));
//   setEqualHeight(productTitles);
//   setEqualHeight(productPrice);
// }, 250));

document.addEventListener("DOMContentLoaded", function() {
  productCardHeight();
  document.querySelectorAll('.product-item__quick-view-button').forEach(button => {
    button.addEventListener('click', () => {
      console.log('Clicked');
      const loyaltyBtn = document.getElementById('bon-loyalty-btn');
      if (loyaltyBtn) {
        loyaltyBtn.classList.add('active');
      }
    });
  });
});

window.addEventListener("resize", debounce(function() {
  productCardHeight();
}, 250));

/***** Variant Images *****/

const container = document.querySelector('.product__media--column-grids');
const originalOrder = Array.from(container.children);

function setFeaturedMedia(featuredMediaId) {

  const mediaItems = container.querySelectorAll('.product__media-item');

  let firstItem = mediaItems[0];
  let targetItem = Array.from(mediaItems).find(item => {
    return parseInt(item.getAttribute('data-media-item-id')) === featuredMediaId;
  });

  if (targetItem && firstItem !== targetItem) {
    const firstItemClone = firstItem.cloneNode(true);
    const targetItemClone = targetItem.cloneNode(true);

    container.replaceChild(targetItemClone, firstItem);
    container.replaceChild(firstItemClone, targetItem);
  }
}

document.addEventListener("product:variant-change", function(event) {
  const featuredMediaId = event.detail.variant.featured_media?.id;

  if (featuredMediaId) {
    setFeaturedMedia(featuredMediaId);
  }
});

/***** Variant Images *****/